var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [
              _vm._v(" Leadership Development \n                        "),
              _c(
                "div",
                {
                  staticClass: "col-12 col-sm-12 col-md-3 col-lg-2 pull-right"
                },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        name: "categoryId",
                        id: "categoryId",
                        label: "text",
                        filterable: false,
                        options: _vm.categoryArr,
                        placeholder: "Select Category"
                      },
                      on: {
                        change: _vm.changedValue,
                        input: function($event) {
                          return _vm.changedCategoryFor()
                        },
                        search: _vm.onSearchCategory
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(option.text) +
                                    "\n                                    "
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "selected-option",
                          fn: function(option) {
                            return [
                              _c("div", { staticClass: "selected d-center" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(option.text) +
                                    "\n                                    "
                                )
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.categoryId,
                        callback: function($$v) {
                          _vm.categoryId = $$v
                        },
                        expression: "categoryId"
                      }
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n                                    Search Parent Category...\n                                "
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "internal-page-main-section leadership-development-main col-12"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "bottom-listing-prog col-12 float-l mt-50" },
              [
                _c(
                  "div",
                  { staticClass: "row", attrs: { id: "VideoMainContainer" } },
                  [
                    _c(
                      "div",
                      {},
                      [
                        _vm._l(_vm.leadershipList, function(text, index) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bottom-listing-prog-des col-12 col-sm-12 col-md-6 col-lg-6 float-l"
                              },
                              [
                                text.video_path != ""
                                  ? [
                                      _c(
                                        "video",
                                        {
                                          attrs: {
                                            width: "560",
                                            controls: "controls",
                                            preload: "metadata"
                                          }
                                        },
                                        [
                                          _c("source", {
                                            attrs: {
                                              src: text.video_path + "#t=0.5",
                                              type: "video/mp4"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                text.video_url != ""
                                  ? [
                                      _c("iframe", {
                                        attrs: {
                                          src: text.video_url,
                                          controls: "",
                                          height: "292",
                                          allowfullscreen: "",
                                          autostart: "0"
                                        }
                                      })
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"
                                  },
                                  [_vm._v(" " + _vm._s(text.video_title) + " ")]
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            (index + 1) % 2 == 0
                              ? [_c("div", { staticClass: "clearfix" })]
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f6e6636", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6e6636","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeadershipDevelopment.vue
// module id = null
// module chunks = 